import React, { useEffect, useCallback, useState} from 'react';
import PitchClock from 'components/apps/PitchClock.js';
import {connect} from 'react-redux';

const MixModules = ({sequencerEngine}) => { 
    return (
        <div className="mix-modules">
          <PitchClock sequencerEngine={sequencerEngine}/>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MixModules);
